<template>
    <div class="flex flex-col items-center lg:justify-center w-full bg-white p-4 md:p-10 md:mt-6 h-full lg:overflow-hidden overflow-y-auto">
      <div class="w-full max-w-md bg-white rounded-lg  px-6  ">
        <h1 class="text-h24 md:text-h32 font-bold text-costeaBlack mt-6 mb-4 text-left">
          Iniciar sesión
        </h1>
        <p class="text-t16 md:text-t18 text-costeaDarkGray text-left mb-6">
          Ingresa tu correo electrónico y contraseña para acceder a Costea
        </p>
        <!-- Componente de formulario -->
        <formField />
        <p class="text-t14 md:text-t16 text-left mt-8 mb-4">
          Al ingresar, estás aceptando los 
          <router-link
            :to="{ name: 'TerminosyCondiciones' }"
            class="text-costeaPrimary hover:text-costeaHover"
          >
            términos y condiciones de uso
          </router-link>
        </p>
        <div class="flex justify-center items-center space-x-4 mt-4 lg:hidden gap-5">
            <a href="https://www.linkedin.com/company/costea-co" target="_blank" class="text-costeaPrimary text-xl md:text-2xl">
              <i class="ri-linkedin-box-fill"></i>
            </a>
            <a href="https://www.instagram.com/costea_app/" target="_blank" class="text-costeaPrimary text-xl md:text-2xl">
              <i class="ri-instagram-fill"></i>
            </a>
          </div>
      </div>
    </div>
  </template>
  


<script>
import FormField from '../../components/Login/FormField'
import { mapState } from 'vuex'
export default {
    name: 'Control',
    components: {
        FormField,
    },
    computed: {
        ...mapState(['costea'])
    }
}
</script>
<style>
* {
  font-family: 'DM Sans', sans-serif;
}
</style>